export const getAvatarPath = path => {
	if (path) {
		return `${path}`
	} else {
		return null
	}
}
